export const NODE_ENV = import.meta.env.NODE_ENV
export const PUBLIC_SENTRY_RELEASE = import.meta.env.PUBLIC_SENTRY_RELEASE
export const HELPSCOUT_WEBHOOK_SECRET = import.meta.env.HELPSCOUT_WEBHOOK_SECRET
